/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 12/01/2025
 * @update 12/01/2025
 * @file src/components/W17/W17F2180
 */

import * as types from '../actions/types.js';

const initialState = {
    dataCboJobsType: [],
    dataCboEmployee: [],
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case types.W17_W17F2000_GET_CBO_JOBS_TYPE_SUCCESS:
            return { ...state, dataCboJobsType: action.data };
        case types.W17_W17F2000_LOAD_CBO_EMPLOYEE_SUCCESS:
            return { ...state, dataCboEmployee: action.data };
        default:
            return state;
    }
}
